import { Injectable } from '@angular/core';
import { Column, IdbUpright, Upright } from '../asset/asset.dto';
import { UPRIGHTS_COLUMNS_STORE, UPRIGHTS_STORE } from '@damofire/data-commons';
import { LockingIndexedService } from '../indexed/locking-indexed.service';
import { UprightService } from './upright.service';

@Injectable()
export class IdbUprightService implements UprightService {
  constructor(private readonly lockingIndexedService: LockingIndexedService) {}

  async get(division: string, id: string): Promise<IdbUpright> {
    return this.lockingIndexedService.getByKey<IdbUpright>(division, UPRIGHTS_STORE, [division, id]);
  }

  list(division: string, systemId: string): Promise<Upright[]> {
    return this.lockingIndexedService.getAllFromIndex<Upright>(division, UPRIGHTS_STORE, 'system', systemId);
  }

  async listColumns(division: string, assetIds: string[], rowIndex?: number): Promise<Column[]> {
    const columns: Column[] = [];

    for (const assetId of assetIds) {
      const all = await this.lockingIndexedService.getAllFromIndex<Column>(division, UPRIGHTS_COLUMNS_STORE, 'asset', assetId);
      all.filter((u: Column) => !rowIndex || u.rowIndex === rowIndex).forEach((c) => columns.push(c));
    }

    return columns;
  }
}
